import React, { useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Collapse from '@material-ui/core/Collapse'
import CardContent from '@material-ui/core/CardContent'
import Divider from '@material-ui/core/Divider'

import { itemExtrasService } from '../services/itemService'
import Spinner from './Spinner'

const useStyles = makeStyles(theme => ({
    cover: {
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    }
}));

const hasNumber = input => /\d/.test(input)

const getQuery = item => {
    if(item.isbn && hasNumber(item.isbn))
        return item.isbn.replace(/\W+/g, ' ').split(' ')[0]

    return ''
}

export default function ItemCardDetails(props) {
    const classes = useStyles();

    const [loading, setloading] = useState(false);
    const [details, setDetails] = useState({});

    const fetchDetails = (item = '') => {
        setloading(true)

        const query = getQuery(item)
        itemExtrasService(query)
        .then(response => {
            setDetails(response.data)
            setloading(false)
        })
        .catch(() => {
            setloading(false)
            setDetails({
                'empty': true,
            })
        })
    }

    useEffect(() => {
        if(props.open && !details.description)
            fetchDetails(props.item)
    }, [props.open])

    return (
        <Collapse in={props.open} timeout="auto">
            <CardContent>

                <Divider />
                {loading ?
                    <Spinner /> :
                    <>
                        <Box display="flex" flexGrow={1} p={2} justifyContent="center">
                            {details.thumbs && 
                                <img src={details.thumbs.smallThumbnail} className={classes.cover} />
                            }
                        </Box>
                        
                        <Typography 
                            variant="body2" 
                            align="justify"
                            color="textSecondary"
                        >
                            {details.empty ?
                                "Sem informações extras para este material" :
                                <>
                                    {details.description}
                                    <Typography variant="caption">
                                        <br /><br />
                                        *Os detalhes são obtidos de fontes externas e podem conter imprecisões
                                    </Typography>
                                </>
                            }
                        </Typography>
                    </>
                }
            </CardContent>
        </Collapse>
    )
}